exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".auth-btn-submit {\n  margin-top: 1rem; }\n\n.form {\n  margin-top: 1rem;\n  width: 100%; }\n\n.auth-form {\n  margin: 7rem auto 0;\n  max-width: 900px; }\n  .auth-form button {\n    align-self: flex-end;\n    max-width: 200px;\n    margin-bottom: 1rem; }\n\n.auth-style {\n  margin-top: 2rem;\n  padding: 1rem;\n  margin: 1rem; }\n\n.cp-auth-form input {\n  margin: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/css/auth/auth.scss
// module id = 658
// module chunks = 0